// extracted by mini-css-extract-plugin
export default {"root":"EmailBuilderNode_root__gQV8n","content":"EmailBuilderNode_content__5Lcgw","title":"EmailBuilderNode_title__DZrDx","contentArea":"EmailBuilderNode_contentArea__KtAIe"};